'use client';

import { useState } from 'react';

import { Button, Typography } from 'lighthouse';

import { withSeparator } from '@/utilities/withSeparator';

import { CAMPAIGN_COUPON_CODE, CAMPAIGN_DISCOUNT_AMOUNT } from '@/constants/batteryToBattery';

import Reveal from '../Reveal';
import { CouponReminderProps } from './models';

import { cornbar } from 'cornbar';
import { Copy, Lock1, TicketDiscount, TickSquare } from 'iconsax-react';

const CouponReminder = ({ isLoggedIn, onLoginRequest }: CouponReminderProps) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyCode = async () => {
        try {
            await navigator.clipboard.writeText(CAMPAIGN_COUPON_CODE);
            setIsCopied(true);
            cornbar.show({
                title: 'کپی شد!',
                description: 'موقع پرداخت سفارش لوازم یدکی واردش کن.',
                variant: 'success'
            });
            setTimeout(() => setIsCopied(false), 2500);
        } catch {
            cornbar.show({
                title: 'خطا کپی نشد!',
                description: `کد تخفیف: ${CAMPAIGN_COUPON_CODE}`,
                variant: 'error'
            });
        }
    };

    return (
        <section className='bg-[#F6F9FF]'>
            <div className='mx-auto w-full max-w-6xl px-5 py-12 sm:py-14'>
                <Reveal>
                    <div
                        className='flex flex-col items-center gap-5 rounded-lg bg-white p-6 text-center shadow-elevation1 ring-1 ring-black/5
                            lg:flex-row lg:justify-between lg:gap-8 lg:p-8 lg:text-right'>
                        <div className='flex flex-col items-center gap-4 lg:flex-row'>
                            <span className='flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-amber-400/15 ring-1 ring-amber-300/50'>
                                <TicketDiscount size={26} color='#D97706' />
                            </span>
                            <div>
                                <Typography variant='h6' component='h2' fontWeight={800} color='blackHighEmphasis'>
                                    {isLoggedIn ? 'کد تخفیفت روی لوازم یدکی هم کار می‌کنه!' : 'یه کد تخفیف این‌طرف‌تر هم منتظرته'}
                                </Typography>
                                <Typography variant='body2' component='p' color='blackMediumEmphasis' className='mt-1.5 leading-7'>
                                    {isLoggedIn
                                        ? `همون کد ${withSeparator(CAMPAIGN_DISCOUNT_AMOUNT)} تومانی رو موقع خرید روغن موتور و لوازم یدکی پایین صفحه هم می‌تونی وارد کنی.`
                                        : `${withSeparator(CAMPAIGN_DISCOUNT_AMOUNT)} تومان تخفیف خرید باتری، روغن موتور و لوازم یدکی؛ فقط با شماره موبایل فعالش کن.`}
                                </Typography>
                            </div>
                        </div>

                        {isLoggedIn ? (
                            <div
                                dir='ltr'
                                className='flex w-full items-center justify-between gap-3 rounded-lg border-2 border-dashed border-amber-400/70
                                    bg-amber-50 px-4 py-3 lg:w-auto lg:min-w-[300px]'>
                                <span className='font-mono select-all text-lg font-bold tracking-[0.25em] text-[#B45309]'>
                                    {CAMPAIGN_COUPON_CODE}
                                </span>
                                <Button
                                    size='small'
                                    variant={isCopied ? 'contained' : 'outlined'}
                                    onClick={handleCopyCode}
                                    startIcon={
                                        isCopied ? (
                                            <TickSquare size={16} color='currentcolor' className='mr-2' />
                                        ) : (
                                            <Copy size={16} color='currentcolor' className='mr-2' />
                                        )
                                    }
                                    className={isCopied ? 'bg-success text-white' : ''}>
                                    {isCopied ? 'کپی شد' : 'کپی کد'}
                                </Button>
                            </div>
                        ) : (
                            <Button
                                size='large'
                                variant='contained'
                                onClick={onLoginRequest}
                                startIcon={<Lock1 size={18} color='currentcolor' className='mr-2' />}
                                className='w-full shrink-0 bg-amber-400 font-extrabold text-[#0A1530] hover:bg-amber-300 lg:w-auto'>
                                دریافت کد تخفیف
                            </Button>
                        )}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default CouponReminder;
